import { socketTvApi } from "./socket.api";

export const { useDriverCalledQuery, useAttendanceCountUpdatedQuery } = socketTvApi;
